import {
  FieldError,
  FieldErrors,
  FieldErrorsImpl,
  Merge,
} from 'react-hook-form';

import type { FormInputsType } from '../@types';

export const sanitizeErrors = (
  errors:
    | FieldErrors<FormInputsType>
    | {
        [k: string]:
          | string
          | FieldError
          | Merge<FieldError, FieldErrorsImpl<any>>;
      },
) =>
  Object.fromEntries(
    Object.entries(errors).map(([key, val]) => [key, val?.message]),
  );

export const unpackErrorMessage = (
  errors: FieldErrors<FormInputsType>,
  name: string,
) =>
  errors[name] ? (errors[name]?.message ? errors[name]?.message : true) : false;
